import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceFunctionalization from '../../space-functionalization'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between space functional usage and space, categorizing how space is used (e.g., research, administration, instruction).',
    dimension: spaceFunctionalization.RESOURCE.payload,
    level: 0,
    name: 'Space Functionalization Entry',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
